/*
Builds a good map with pins
NEEDS TO HAVE THE GOOGLE SCRIPTS ADDED TO HELP DROP PINS ETC
	<div class="google-map" data-zoom="12">
		<div class="marker" data-lat="<?php echo $iLat;?>" data-lng="<?php echo $iLong;?>" data-marker="<?php echo THEME_DIRECTORY_IMGS;?>icons/map-pin.svg"></div>
	</div>

*/

function fnGoogleMap( i, oSection ) {
	var oMaps = $(oSection);

	$(document).ready(function(){
		oMaps.each(function(){
			render_map( $(this) );
		});
	});




	function render_map( $el ) {

		// var
		var $markers = $el.find('.marker'),
			iZoom 	= parseInt($el.attr('data-zoom'),0);

		// vars
		var args = {
			disableDefaultUI	: true,
			zoom				: iZoom,
			center				: new google.maps.LatLng(53.7749985,-1.6032553),
			mapTypeId			: google.maps.MapTypeId.ROADMAP
		};

		// create map
		var map = new google.maps.Map( $el[0], args);

		// add a markers reference
		map.markers = [];

		// add markers
		$markers.each(function(){

	    	add_marker( $(this), map );

		});

		// center map
		center_map( map,iZoom );

	}






	function add_marker( $marker, map ) {

		// var
		var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );

		// create marker
		var marker = new google.maps.Marker({
			position	: latlng,
			map			: map,
			icon		: $marker.attr('data-marker')
		});

		// add to array
		map.markers.push( marker );

		// if marker contains HTML, add it to an infoWindow
		if( $marker.html() )
		{
			// create info window
			var infowindow = new google.maps.InfoWindow({
				content		: $marker.html()
			});

			// show info window when marker is clicked
			google.maps.event.addListener(marker, 'click', function() {

				infowindow.open( map, marker );

			});
		}

	}

	/*
	*  center_map
	*
	*  This function will center the map, showing all markers attached to this map
	*
	*  @type	function
	*  @date	8/11/2013
	*  @since	4.3.0
	*
	*  @param	map (Google Map object)
	*  @return	n/a
	*/

	function center_map( map,iZoom ) {
		var iZoom = iZoom;

		// vars
		var bounds = new google.maps.LatLngBounds();

		// loop through all markers and create bounds
		$.each( map.markers, function( i, marker ){

			var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );

			bounds.extend( latlng );

		});

		// only 1 marker?
		if( map.markers.length == 1 )
		{
			// set center of map
		    map.setCenter( bounds.getCenter() );
		    map.setZoom( iZoom );
		}
		else
		{
			// fit to bounds
			map.fitBounds( bounds );
		}

	}




}